// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import _ from 'underscore';
import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { BoardCleanUpView } from 'app/scripts/views/board/BoardCleanUpView';
import { Auth } from 'app/scripts/db/Auth';
import { l } from 'app/scripts/lib/localize';
import headerTemplate from 'app/scripts/views/templates/board_header';
import { InspiringBoardsWorkspaceIds } from 'app/scripts/data/inspiring-boards-workspace-ids';
import { seesVersionedVariation } from '@trello/feature-flag-client';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { ErrorBoundary, sendErrorEvent } from '@trello/error-reporting';
import { TimelineViewWrapper } from 'app/src/components/TimelineViewWrapper';
import { SingleBoardCalendarView } from 'app/src/components/BoardCalendarView';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { AutomaticReports } from 'app/src/components/Butler';
import { navigate } from 'app/scripts/controller/navigate';
import { WindowSize } from 'app/scripts/lib/window-size';
import { ButlerBoardButtons } from 'app/src/components/Butler/Buttons/ButlerBoardButtons';
import { PremiumFeature } from '@trello/product-features';
import { LazyViewSwitcher as ViewSwitcher } from 'app/src/components/ViewSwitcher';
import { BoardFacepile } from 'app/src/components/BoardFacepile';

import { Null } from 'app/src/components/Null';
import { SingleBoardTableView } from 'app/src/components/TableView/SingleBoardTableView';
import { SingleBoardViewFilterPopoverButtonContainer } from 'app/src/components/FilterPopover';
import { filteredCardsCountState } from 'app/src/components/FilterPopover/filteredCardsCountState';
import { BoardShareButton } from 'app/src/components/BoardShareButton';
import { BoardHeader } from 'app/src/components/BoardHeader';
import { BoardHeaderShowSidebarButton } from 'app/src/components/BoardHeaderShowSidebarButton';
import { LazyBoardDescriptionSpotlight } from 'app/src/components/BoardDescriptionSpotlight';
import { N900, N30 } from '@trello/colors';
import { wasShowSidebarSpotlightViewedState } from 'app/src/components/BoardDescriptionSpotlight/useWasShowSidebarSpotlightViewed';
import { isEmbeddedInAtlassian } from '@trello/browser';
import { BoardJoinButton } from 'app/src/components/BoardJoinButton';

export const renderBoardHeader = function () {
  const isPremOrgAdmin = this.model.isPremOrgAdmin(Auth.me());

  const data = {
    name: this.model.get('name'),
    canRename: isPremOrgAdmin || this.model.owned(),
    isLoggedIn: Auth.isLoggedIn(),
    isUntitled: this.model.get('name') === l(['untitled board']),
    canJoin: this.model.canJoin(),
    canInviteMembers: this.model.canInviteMembers(),
    canAssign: this.model.editable(),
    isEmbeddedInAtlassian: isEmbeddedInAtlassian(),
    isTemplate: this.model.isTemplate(),
    hasEditPrivileges: this.model.editable(),
    shouldRenderPartialReactBoardHeader: seesVersionedVariation(
      'panorama.board-header-rewrite',
      'alpha',
    ),
  };

  data.starTooltipKey = this.model.isTemplate()
    ? 'click-to-star-or-unstar-this-template-starred-templates-show-up-at-the-top-of-your-boards-list'
    : 'click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list';

  const organization = this.model.getOrganization();
  if (organization) {
    data.showCopyButton = _.contains(
      InspiringBoardsWorkspaceIds,
      organization.id,
    );
  }

  // Work-around to avoid data loss from re-populating header and
  // over-writing filtering react component
  const britaReactRoot = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  $('.js-board-header', this.$el).html(headerTemplate(data));

  const newBritaReactRoot = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  if (britaReactRoot) {
    newBritaReactRoot.parentNode.replaceChild(
      britaReactRoot,
      newBritaReactRoot,
    );
  }

  this.renderShowSidebarButton();
  this.renderBoardShareButton();
  this.renderBritaBoardFilterButton();
  this.renderPermissionLevel();
  this.renderBoardHeaderCalendar();
  this.renderBoardHeaderSubscribed();
  this.renderBoardHeaderMap();
  this.renderFilteringStatus();
  this.renderBoardHeaderStarred();
  this.renderPluginButtons();
  this.renderButlerBoardButtons();
  this.renderBoardHeaderFacepile();
  this.renderBoardTemplateBadge();
  this.renderWorkspacesAutoNameAlert();

  this.renderPluginDropdownList();
  this.renderPluginHeaderButtons();

  this.renderViewSwitcher();
  this.renderPartialReactBoardHeader();
  this.renderReactJoinButton();
  this.renderReactFacepile();

  return this;
};

export const renderReactFacepile = function () {
  const facepileTarget = this.el.querySelector(
    '.js-react-board-header-facepile',
  );

  if (!facepileTarget) {
    return;
  }
  renderComponent(
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-panorama',
        feature: 'Board Facepile',
      }}
      errorHandlerComponent={Null}
    >
      <BoardFacepile boardId={this.model.id} />
    </ErrorBoundary>,
    facepileTarget,
  );
};

export const removeReactFacepile = function () {
  if ($('.js-react-board-header-facepile', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.js-react-board-header-facepile'),
    );
  }
};

export const renderReactJoinButton = function () {
  const target = this.el.querySelector('.js-react-board-header-join-button');

  if (!target) {
    return;
  }
  renderComponent(
    <BoardJoinButton
      boardId={this.model.id}
      workspaceId={this.model.getOrganization()?.id}
      enterpriseId={this.model.getEnterprise()?.id}
    />,
    target,
  );
};

export const removeReactJoinButton = function () {
  if ($('.js-react-board-header-join-button', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.js-react-board-header-join-button'),
    );
  }
};

export const renderPartialReactBoardHeader = function () {
  const headerTarget = this.el.querySelector('.js-react-header-wrapper');

  if (!headerTarget) {
    return;
  }
  renderComponent(<BoardHeader boardId={this.model.id} />, headerTarget);
};

export const removePartialReactBoardHeader = function () {
  if ($('.js-react-header-wrapper', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.js-react-header-wrapper'),
    );
  }
};

export const renderBoardHeaderStarred = function () {
  if (this.model.isStarred()) {
    $('.js-star-board > .board-header-btn-icon', this.$el).removeClass(
      'icon-star',
    );
    $('.js-star-board > .board-header-btn-icon', this.$el).addClass(
      'icon-starred',
    );
  } else {
    $('.js-star-board > .board-header-btn-icon', this.$el).removeClass(
      'icon-starred',
    );
    $('.js-star-board > .board-header-btn-icon', this.$el).addClass(
      'icon-star',
    );
  }
  return this;
};

// always show hollow star on hover
export const hoverStar = function () {
  $('.js-star-board > .board-header-btn-icon', this.$el).removeClass(
    'icon-starred',
  );
  $('.js-star-board > .board-header-btn-icon', this.$el).addClass('icon-star');
};

// active state when clicking on state (onmousedown)
export const clickStar = function () {
  if (this.model.isStarred()) {
    $('.js-star-board > .board-header-btn-icon', this.$el).removeClass(
      'icon-starred',
    );
    $('.js-star-board > .board-header-btn-icon', this.$el).addClass(
      'icon-star',
    );
  } else {
    $('.js-star-board > .board-header-btn-icon', this.$el).removeClass(
      'icon-star',
    );
    $('.js-star-board > .board-header-btn-icon', this.$el).addClass(
      'icon-starred',
    );
  }
  return this;
};

export const toggleStarred = function () {
  const { boardStarList } = Auth.me();
  const boardStar = boardStarList.getBoardStar(this.model.id);
  if (boardStar) {
    boardStarList.unstarBoard(this.model.id);
  } else {
    boardStarList.starBoard(this.model.id);
  }

  Analytics.sendUpdatedBoardFieldEvent({
    field: 'star',
    value: !!boardStar,
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
    },
  });

  return this;
};

export const clearFilters = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'clearBoardFilterButton',
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
      organization: {
        id: this.model.getOrganization()?.id,
      },
      enterprise: {
        id: this.model.getEnterprise()?.id,
      },
    },
  });

  this.model.filter.clear();
};

export const showCleanUp = function (e) {
  stopPropagationAndPreventDefault(e);

  const view = new BoardCleanUpView({
    model: this.model,
    modelCache: this.modelCache,
  });
  Dialog.show({
    view,
    maxWidth: 800,
    hide() {
      return view.abort();
    },
  });
};

export const renderShowSidebarButton = function () {
  const node = this.el.querySelector('.show-sidebar-button-react-root');

  if (node) {
    // We need a solid opaque background color for the target so it doesn't get washed
    // out by the spotlight overlay.
    const targetBackgroundColor =
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
      this.model.getPref('backgroundBrightness') === 'light' ? N30 : N900;
    this.unmountBoardDescriptionSpotlight?.();

    this._onClickNext = () => {
      wasShowSidebarSpotlightViewedState.setValue(true);
      this.setSidebarShow();
    };
    this._isSidebarOpen = () => this.model?.viewState.get('showSidebar');
    this._setSidebarShow = () => this.setSidebarShow();
    this.unmountBoardDescriptionSpotlight = renderComponent(
      <LazyBoardDescriptionSpotlight
        targetName="showSidebarButton"
        target={
          <BoardHeaderShowSidebarButton
            showSidebar={this._setSidebarShow}
            eventContainers={{
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            }}
          />
        }
        targetBgColor={targetBackgroundColor}
        isSidebarOpen={this._isSidebarOpen}
        onClickNext={this._onClickNext}
        eventContainers={formatContainers({
          idBoard: this.model.id,
          idOrganization: this.model.getOrganization()?.id,
          idEnterprise: this.model.getEnterprise()?.id,
        })}
        boardId={this.model.id}
      />,
      node,
    );
  }
};

export const removeShowSidebarButton = function () {
  this.unmountBoardDescriptionSpotlight?.();
};

export const renderBoardShareButton = function () {
  const node = this.el.querySelector('.board-share-button');
  if (node) {
    renderComponent(
      <BoardShareButton
        idBoard={this.model.id}
        idOrg={this.model.getOrganization()?.id}
      />,
      node,
    );
  }
};

export const removeBoardShareButton = function () {
  if ($('.board-share-button', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.board-share-button'),
    );
  }
};

export const renderBritaBoardFilterButton = function () {
  const targetNodeForButton = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  if (!targetNodeForButton) {
    return;
  }
  const isDateBasedView =
    Controller.showingCalendarView() || Controller.showingTimeline();

  const appearance =
    this.model.getPref('backgroundBrightness') === 'light'
      ? 'transparent-dark'
      : 'transparent';

  renderComponent(
    <SingleBoardViewFilterPopoverButtonContainer
      idBoard={this.model.id}
      appearance={appearance}
      isDateBasedView={isDateBasedView}
    />,
    targetNodeForButton,
  );
};

export const removeBritaBoardFilterButton = function () {
  const container = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );
  if (container) {
    ReactDOM.unmountComponentAtNode(container);
  }
};

export const renderViewSwitcher = function () {
  const targetNodeForSwitcherInHeader = this.el.querySelector(
    '.js-board-views-switcher',
  );

  if (!targetNodeForSwitcherInHeader) {
    return;
  } else {
    renderComponent(
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-panorama',
          feature: 'View Switcher',
        }}
        errorHandlerComponent={Null}
      >
        <ViewSwitcher idBoard={this.model.id} />
      </ErrorBoundary>,
      targetNodeForSwitcherInHeader,
    );
  }
};

export const removeBoardViewsButton = function () {
  if ($('.js-board-views-switcher', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.js-board-views-switcher'),
    );
  }
};

export const showTimeline = function () {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (hasViewsFeature) {
    $('#board', this.$el).addClass('hide');
    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <TimelineViewWrapper
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id, params) => {
          Controller.showCardDetail(this.modelCache.get('Card', id), params);
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

export const showCalendarView = function () {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  const canShowCalendarView = hasViewsFeature;

  if (canShowCalendarView) {
    $('#board', this.$el).addClass('hide');
    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <SingleBoardCalendarView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          Controller.showCardDetail(this.modelCache.get('Card', id));
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true, shouldTrack: false });
  }
};

export const showTable = function () {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (hasViewsFeature) {
    $('#board', this.$el).addClass('hide');

    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <SingleBoardTableView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          Controller.showCardDetail(this.modelCache.get('Card', id));
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

export const closeSingleBoardView = function () {
  const viewContainer = this.el.querySelector('.js-board-view-container');
  if (viewContainer) {
    ReactDOM.unmountComponentAtNode(viewContainer);
  }
  $('#board', this.$el).removeClass('hide');
  $('.js-list-name-input', this.$el).trigger('autosize.resize', false);

  this.renderViewSwitcherDebounced();
  this.renderBritaBoardFilterButtonDebounced();
};

export const renderButlerBoardButtons = function () {
  const reactRoot = this.el.querySelector('.js-butler-header-btns');
  if (this.model?.editable()) {
    if (reactRoot) {
      const renderTraceId = Analytics.startTask({
        taskName: 'view-butlerButtons/board',
        source: 'boardScreen',
      });
      try {
        renderComponent(
          <ButlerBoardButtons
            idBoard={this.model.id}
            idOrganization={this.model.get('idOrganization')}
            renderTraceId={renderTraceId}
          />,
          reactRoot,
        );
      } catch (err) {
        sendErrorEvent(err, {
          tags: {
            ownershipArea: 'trello-workflowers',
            feature: 'Butler on Boards',
          },
        });
      }
    }
  }
};

export const navigateToAutomaticReports = function (reportType) {
  const automaticReportView = Controller.getBoardUrl(
    this.model.id,
    `butler/reports/${reportType}`,
  );

  navigate(automaticReportView, { trigger: true });

  // Close the sidebar menu for window sizes that aren't extra large.

  if (!WindowSize.fExtraLarge) {
    this.sidebarView.hideSidebar();
  }
};

// This is actually pretty generic and just closes any overlays;
// if it ever needs reuse, feel free to rename it.
export const closeAutomaticReports = function (idBoard) {
  const boardUrl = Controller.getBoardUrl(idBoard || this.model.id);
  navigate(boardUrl, { trigger: true });
};

export const showAutomaticReports = function (reportType) {
  const idBoard = this.model.id;
  const container = this.el.querySelector('.js-board-view-container');
  $('#board', this.$el).addClass('hide');

  renderComponent(
    <AutomaticReports
      reportType={reportType}
      idBoard={idBoard}
      idOrganization={this.model.get('idOrganization')}
      boardName={this.model.get('name')}
      // eslint-disable-next-line react/jsx-no-bind
      closeView={() => closeAutomaticReports(idBoard)}
    />,
    container,
  );
  Analytics.sendViewedComponentEvent({
    componentType: 'overlay',
    componentName: 'butlerReportBuilderOverlay',
    source: 'butlerReportBuilderOverlay',
    attributes: {
      reportType,
    },
  });
};

// There are many things that could cause the filter count to change
const watchedEvents = [
  // We could learn about a new card that matches the filter
  'add:Card',
  // A card that matched the filter may have been deleted
  'remove:Card',
  // A card may change so that it is no a match (or isn't one anymore)
  'change:Card',
  // We could learn about a new list that has matches in it (e.g. a list may have been moved to this board)
  'add:List',
  // A list that had matches in it could have been moved off of the board
  'remove:List',
  // A list with matches could have been closed or re-opened
  'change:List',
].join(' ');

export const initializeFilterCountMonitoring = function () {
  let isMonitoring = false;
  const updateCount = this.frameDebounce(() => {
    const boardCardCount = this.model.filter.isFiltering()
      ? this.model
          .openCards()
          .filter((card) => this.model.filter.satisfiesFilter(card)).length
      : 0;

    // Keep the filtered cards count for the board in sync with a shared state,
    // to avoid an unnecessary API call for SBVs. If this gets migrated to GraphQL
    // and we have the data in cache, we can eventually deprecate this.
    if (boardCardCount !== filteredCardsCountState.value.count) {
      filteredCardsCountState.setValue({ count: boardCardCount });
    }
  });

  const updateMonitoring = () => {
    const isFiltering = this.model.filter.isFiltering();
    if (isFiltering) {
      if (!isMonitoring) {
        isMonitoring = true;
        // Listen for all of the watched events that happen in the ModelCache, including
        // (possibly) events related to other boards.  Some of the events won't affect the
        // count (e.g. if a card changes position, or we got an update about a card on another
        // board) but counting the cards isn't too expensive if we're debouncing it
        this.listenTo(this.modelCache, watchedEvents, updateCount);
      }
      // The filter changed, so the count may be different
      updateCount();
    } else if (!isFiltering && isMonitoring) {
      isMonitoring = false;
      this.stopListening(this.modelCache, watchedEvents, updateCount);
    }
  };

  // Only monitor the model cache if we're currently filtering
  this.listenTo(this.model.filter, 'change', updateMonitoring);
  updateMonitoring();
};
